export const queryKeys = {
    allWorkflows: () => ['allWorkflows'],
    workflowRuns: (workflowId: string) => ['runs', workflowId],
    workflowRunsCount: (workflowId: string) => ['runsCount', workflowId],
}
